export default {
  COURSE_UPDATED_WITH_TOPIC_LESSONS: (state, courseWithTopicLessons) => {
    state.courseWithTopicLessons = courseWithTopicLessons
  },

  TRENDING_COURSES_UPDATED: (state, courses) => {
    state.trending = courses
  },

  POPULAR_COURSES_UPDATED: (state, courses) => {
    state.popular = courses
  },

  FEATURED_COURSES_UPDATED: (state, courses) => {
    state.featured = courses
  },

  NEW_COURSES_UPDATED: (state, courses) => {
    state.newCourses = courses
  },

  COURSE_FEEDBACK_SUBMITTED: (state, feedbackSubmission) => {
    state.feedbackSubmission = feedbackSubmission
  },

  COURSES_ALL_COURSES_UPDATED: (state, courses) => {
    state.allCourses = courses
  },
}
